import axios, { HttpStatusCode } from "axios";
import { StatusMessageResponse } from "../../../../common/interfaces/status-message-response";

export async function updateMaintenancePoint(id: string, data: any, token: string): Promise<StatusMessageResponse> {
    try {
      const response = await axios.patch(process.env.REACT_APP_BASE_URL+'/manutencao/apontamento/'+id, 
        data, 
        {
            headers: {
                Authorization: 'Bearer ' + token
            }
        }
      );
  
      const res = response.data; // Supondo que a resposta de criação seja retornado pelo backend
      return res;
    } catch (error) {
      return {
        statusCode: HttpStatusCode.InternalServerError,
        message: 'Falha na atualização do apontamento de manutenção',
      }
    }
}